import { GET_USERS_SUCCESS } from "./users.types";

const initialState = {
  usersList: null,
};

export const usersReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_USERS_SUCCESS:
      return {
        ...state,
        usersList: action.payload,
      };

    default:
      return state;
  }
};
